import {
  FETCH_COUNTRIES,
  FETCH_COUNTRIES_SUCCESS,
  FETCH_DOMAIN_DETAILS,
  FETCH_DOMAIN_DETAILS_FAILED,
  FETCH_DOMAIN_DETAILS_SUCCESS,
  FETCH_LISTINGS,
  FETCH_LISTINGS_SUCCESS,
  FETCH_QUALIFICATIONS,
  FETCH_QUALIFICATIONS_SUCCESS,
  FETCH_SPECIALITIES,
  FETCH_SPECIALITIES_SUCCESS,
} from '../actions/types';

const initState = {
    regions: [],
    qualifications: [],
    specialities: [],
};
const listings = (
    state = {
        status: undefined,
        data: initState,
        countries: [],
        domainDetails: {},
        domainFailed: false,
    },
    action
) => {
    switch (action.type) {
        case FETCH_LISTINGS:
            return Object.assign({}, state, {status: 'fetching'});
        case FETCH_LISTINGS_SUCCESS:
            return Object.assign({}, state, {status: 'success', data: action.data});
        case FETCH_COUNTRIES:
            return Object.assign({}, state, {status: ''});
        case FETCH_COUNTRIES_SUCCESS:
            return Object.assign({}, state, {status: 'success', countries: action.data});
        case FETCH_SPECIALITIES:
            return Object.assign({}, state, {status: 'fetching'});
        case FETCH_SPECIALITIES_SUCCESS:
            return Object.assign({}, state, {status: 'success', data: {...state.data, specialities: action.data}});
        case FETCH_QUALIFICATIONS:
            return Object.assign({}, state, {status: 'fetching'});
        case FETCH_QUALIFICATIONS_SUCCESS:
            return Object.assign({}, state, {status: 'success', data: {...state.data, qualifications: action.data}});
        case FETCH_DOMAIN_DETAILS:
            return Object.assign({}, state, {status: 'fetching'});
        case FETCH_DOMAIN_DETAILS_SUCCESS:
            return Object.assign({}, state, {status: 'success', domainDetails: action.data, domainFailed: false});
        case FETCH_DOMAIN_DETAILS_FAILED:
            return Object.assign({}, state, {
                status: 'failed',
                domainDetails: action.data ? action.data : {},
                domainFailed: true
            });
        default:
            return state;
    }
};

export default listings;
